import React, { useState } from "react";
import Logo from "../assets/logo.png";
import { CheckCircle, CopyAll } from "@mui/icons-material";
const WifiPage = ({ qrData }) => {
  const [notification, setNotification] = useState("");
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>
      {notification ? (
        <div className="success_dialogue">
          <div className="success_dialogue_icon">
            <CheckCircle />
          </div>
          <div className="success_dialogue_heading">{notification}</div>
        </div>
      ) : (
        ""
      )}
      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>

      <div className="sign_up_form_body">
        <div className="sign_up_form_heading">Wifi</div>
        {/*show wifi name and passwords*/}
        <div className="sign_up_form">
          <div className="input-wrapper" style={{ marginBottom: 0 }}>
            <h4>Wifi Name</h4>
          </div>
          <div className="input-wrapper" style={{ marginTop: 0 }}>
            <input
              type="text"
              placeholder="Wifi Name"
              value={qrData?.wifi_name || ""}
              onChange={(e) => {}}
            />
            <span
              className="clear-icon"
              onClick={() => {
                //copy on clipboard
                navigator.clipboard.writeText(qrData?.wifi_name || "");
                setNotification("Name copied to clipboard");
              }}
            >
              <CopyAll />
            </span>
          </div>
          <div className="input-wrapper" style={{ marginBottom: 0 }}>
            <h4>Wifi Password</h4>
          </div>
          <div className="input-wrapper" style={{ marginTop: 0 }}>
            <input
              type="text"
              placeholder="Wifi Password"
              value={qrData?.wifi_password || ""}
              onChange={(e) => {}}
            />
            <span
              className="clear-icon"
              onClick={() => {
                //copy on clipboard
                navigator.clipboard.writeText(qrData?.wifi_password || "");
                setNotification("Password copied to clipboard");
              }}
            >
              <CopyAll />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WifiPage;
